import styled from 'styled-components'

// Constants
import {colors} from '~/constants/style'

const Search = styled.form`
  display: flex;
  height: 40px;
  margin-bottom: 40px;
`

Search.InputWrapper = styled.div`
  width: 100%;
  border: 1px solid ${colors.gray};
  border-right: none;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`

Search.Input = styled.input.attrs({type: 'text'})`
  padding: 0 12px;
  border: none;
  height: 100%;
  width: 100%;
`

Search.SubmitBtn = styled.button.attrs({type: 'submit'})`
  border: none;
  padding: 0 12px;
  background: ${colors.green};

  svg {
    color: white;
  }
`

export default Search
